import { render, staticRenderFns } from "./ColumnStockDropDown.vue?vue&type=template&id=ca20ca50&scoped=true"
import script from "./ColumnStockDropDown.vue?vue&type=script&lang=js"
export * from "./ColumnStockDropDown.vue?vue&type=script&lang=js"
import style0 from "./ColumnStockDropDown.vue?vue&type=style&index=0&id=ca20ca50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca20ca50",
  null
  
)

export default component.exports